import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-email-verification',
    templateUrl: './email-verification.component.html',
    styleUrls: ['./email-verification.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class EmailVerificationComponent implements Component {

}
